import api from "./api";

const registrationLocalStorageKey = "webPushRegistrationKey";

const base64UrlToUint8Array = base64Url => {
	const padding = "=".repeat((4 - (base64Url.length % 4)) % 4);
	const base64 = `${base64Url}${padding}`.replace(/-/g, "+").replace(/_/g, "/");
	const rawData = window.atob(base64);
	const output = new Uint8Array(rawData.length);

	for (let i = 0; i < rawData.length; i += 1) {
		output[i] = rawData.charCodeAt(i);
	}

	return output;
};

const getPublicKey = async () => {
	const { data } = await api.get("/web-push/public-key");
	return data.publicKey;
};

const saveSubscriptionRequest = subscription =>
	api.post("/web-push/subscriptions", {
		subscription: subscription.toJSON()
	});

const refreshAuthToken = async () => {
	const { data } = await api.post("/auth/refresh_token");
	if (!data?.token) return;

	localStorage.setItem("token", JSON.stringify(data.token));
	api.defaults.headers.Authorization = `Bearer ${data.token}`;
};

const saveSubscription = async subscription => {
	try {
		await saveSubscriptionRequest(subscription);
		return;
	} catch (error) {
		if (![401, 403].includes(error?.response?.status)) {
			throw error;
		}
	}

	await refreshAuthToken();
	await saveSubscriptionRequest(subscription);
};

export const ensureWebPushSubscription = async () => {
	if (!("serviceWorker" in navigator)) return;
	if (!("PushManager" in window)) return;
	if (!("Notification" in window)) return;

	const publicKey = await getPublicKey();
	if (!publicKey) return;

	const registration = await navigator.serviceWorker.register("/push-sw.js", {
		scope: "/"
	});

	let permission = Notification.permission;
	if (permission === "default") {
		permission = await Notification.requestPermission();
	}

	if (permission !== "granted") return;

	let subscription = await registration.pushManager.getSubscription();
	const registeredKey = localStorage.getItem(registrationLocalStorageKey);

	if (subscription && registeredKey !== publicKey) {
		await subscription.unsubscribe();
		subscription = null;
	}

	if (!subscription) {
		subscription = await registration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: base64UrlToUint8Array(publicKey)
		});
	}

	await saveSubscription(subscription);
	localStorage.setItem(registrationLocalStorageKey, publicKey);
};
